'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var reactTextMask = require('../node_modules/react-text-mask/dist/reactTextMask.js');
var TextField = require('@material-ui/core/TextField');
var InputAdornment = require('@material-ui/core/InputAdornment');
var IconButton = require('@material-ui/core/IconButton');
var Tooltip = require('@material-ui/core/Tooltip');
var AutoAwesomeIcon = require('@material-ui/icons/AutoAwesome');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var TextField__default = /*#__PURE__*/_interopDefaultLegacy(TextField);
var InputAdornment__default = /*#__PURE__*/_interopDefaultLegacy(InputAdornment);
var IconButton__default = /*#__PURE__*/_interopDefaultLegacy(IconButton);
var Tooltip__default = /*#__PURE__*/_interopDefaultLegacy(Tooltip);
var AutoAwesomeIcon__default = /*#__PURE__*/_interopDefaultLegacy(AutoAwesomeIcon);

var _excluded = ["mask", "value", "onChange", "autoFormat"];
/**
 * Breaks a string mask value into an array where each '#' is replaced wtih
 * a /\d/ and all other characters are kept as is.
 */

function convertStringMaskToArray() {
  var stringMask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return Array.from(stringMask).map(c => {
    if (c === '#') {
      return /\w/;
    }

    return c;
  });
}

var AutoFormattedTextField = _ref => {
  var {
    mask = '',
    value = '',
    onChange,
    autoFormat = false
  } = _ref,
      textFieldProps = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var [isAutoFormatting, setIsAutoFormatting] = React__namespace.useState(autoFormat);

  function handleChange(event) {
    var _result$conformedValu;

    var rawValue = event.target.value;

    if (!isAutoFormatting || !mask || value.startsWith(rawValue)) {
      return onChange(event, rawValue);
    }

    var formattedMask = convertStringMaskToArray(mask);
    var result = reactTextMask.reactTextMask.conformToMask(rawValue, formattedMask, {
      guide: false
    });
    return onChange(event, (_result$conformedValu = result === null || result === void 0 ? void 0 : result.conformedValue) !== null && _result$conformedValu !== void 0 ? _result$conformedValu : '');
  }

  return /*#__PURE__*/React__namespace.createElement(TextField__default['default'], _rollupPluginBabelHelpers['extends']({}, textFieldProps, {
    value: value,
    onChange: handleChange,
    InputProps: _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, textFieldProps.InputProps), {}, {
      endAdornment: autoFormat && /*#__PURE__*/React__namespace.createElement(InputAdornment__default['default'], {
        position: "end"
      }, /*#__PURE__*/React__namespace.createElement(Tooltip__default['default'], {
        arrow: true,
        title: isAutoFormatting ? 'Turn auto-formatting OFF' : 'Turn auto-formatting ON'
      }, /*#__PURE__*/React__namespace.createElement(IconButton__default['default'], {
        onClick: () => setIsAutoFormatting(!isAutoFormatting),
        color: isAutoFormatting ? 'primary' : 'default'
      }, /*#__PURE__*/React__namespace.createElement(AutoAwesomeIcon__default['default'], null))))
    })
  }));
};
AutoFormattedTextField.propTypes = {
  /** Mask format value */
  mask: index.string,

  /** Value of the input */
  value: index.string,

  /** Callback when the input changes */
  onChange: index.func,

  /** If `true`, the mask function will be applied when `onChange` is called. */
  autoFormat: index.bool
};

exports.AutoFormattedTextField = AutoFormattedTextField;
exports.default = AutoFormattedTextField;
